<template>
  <div :class="{ active: opened }" class="side-box">
    <span class="side-box__overlay" />
    <div
      :class="{
        opened: opened,
        'last-active': opened
      }"
      class="side-box__inner"
    >
      <div class="side-box__header d-flex justify-content-between align-items-center">
        <div class="atom-back atom-back--gray" @click="toggleConfirmation()">
          <div class="atom-back__inner d-flex align-items-center">
            <img src="@/assets/icons/arrows/arr-gray-left.svg" />
            <span>{{ $t("zpet") }}</span>
          </div>
        </div>
        <button class="btn btn-primary" @click="runSave()">
          <div class="atom-icon">
            <img src="@/assets/icons/actions/ico-btn-ulozit.svg" />
          </div>
          {{ $t("ulozit") }}
        </button>
      </div>
      <div class="side-box__title">
        <h2>
          {{ $t("upravaSloupcu") }}
        </h2>
      </div>
      <div class="side-box__content">
        <div v-if="errors.project" class="text-danger">
          {{ errors.project }}
        </div>
        <div class="my-4">
          <div class="side-box__row d-flex align-items-center mt-3" />

          <draggable v-model="data">
            <div v-for="item in data" :key="item?.title">
              <div v-if="item" class="item">
                <div class="item__controll">
                  <div
                    :class="{ checked: item.show }"
                    class="custom-control custom-control--checkbox"
                    @click="item.show = !item.show"
                  >
                    <input class="custom-control-input" type="checkbox" />
                  </div>
                </div>
                <div class="item__name">
                  <div class="item__title">
                    {{ $t(item.title) }}
                  </div>
                  <div class="item__title__ico" style="margin-left: auto">
                    <div class="atom-icon">
                      <img src="@/assets/icons/ico-ico-hamburger.svg" />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </draggable>
        </div>
      </div>
    </div>
    <SaveConfirmationModal
      :opened="openedConfirmation"
      :text="'chceteUlozitProvedeneZmeny'"
      @close="toggleConfirmation"
      @no="closeBox()"
      @yes="runSave()"
    />
    <div v-if="errorsToTranslate.length > 0">
      <ErrorModal :centered="true" :errors="errorsToTranslate" :opened="openedError" @close="openedError = false" />
    </div>
  </div>
</template>

<script>
// import axios from "axios";
import ErrorModal from "@/components/confirmations/translatedErrors.vue"
import SaveConfirmationModal from "@/components/confirmations/save.vue"
import { VueDraggableNext } from "vue-draggable-next"

export default {
  components: {
    SaveConfirmationModal,
    ErrorModal,
    draggable: VueDraggableNext
  },
  props: {
    opened: Boolean,
    columns: Object,
    columnsType: String
  },
  data() {
    return {
      data: [],
      formValidationErrors: [],
      errors: {
        project: ""
      },
      openedError: false,
      errorsToTranslate: [],
      openedConfirmation: false
    }
  },
  computed: {
    listOne() {
      return this.items.filter((item) => item.list === 1)
    }
  },
  watch: {},
  mounted() {
    this.data = this.toArray(this.columns)

    //console.log("xar");
    //console.log(this.data);
  },
  methods: {
    openBox(box) {
      this.$emit("openBox", box)
    },
    closeBox() {
      this.$emit("closeBox")
    },
    async runSave() {
      var columns = this.toObject(this.data)
      localStorage.setItem(this.columnsType, JSON.stringify(columns))

      this.closeBox()
    },
    toggleConfirmation() {
      this.openedConfirmation = this.openedConfirmation ? false : true
    },
    toObject(arr) {
      var rv = {}
      for (var i = 0; i < arr.length; ++i) {
        rv[arr[i].key] = arr[i]
        rv[arr[i].key].order = i + 2
      }
      return rv
    },
    toArray(obj) {
      const _boj = JSON.parse(JSON.stringify(obj))
      var arr = []
      for (const [key, value] of Object.entries(_boj)) {
        var item = value
        item["key"] = key
        arr[value.order - 2] = item
      }
      return arr
    }
  }
}
</script>

<style scoped>
.item {
  display: flex;
  border: 1px solid #efefef;
}

.item__controll {
  padding: 14px;
  padding-top: 17px;
  padding-right: 8px;
  padding-left: 18px;
  border-right: 1px solid #efefef;
}

.item__name {
  width: 100%;
  padding: 14px;
  display: flex;
  justify-content: space-between;
}

.item__title__ico {
  cursor: move;
}
</style>
